import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { PlusIcon } from "../../assets/Icons";
import { handleCopy } from "../../utils";
import { Tooltip } from "@mui/material";
import apiClient from "../../apiClient";
import { SSO_URL } from "../../env";
import { FETCH_DIRECTORY_CHANNELS } from "../../apiClient/apiEndpoints";

const DirectoryChannelList = ({ directoryId, type }) => {
  const [copyText, setCopyText] = useState("Copy");
  const [channels, setChannels] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();

  const handleCreateChannel = () => {
    navigate(`/dashboard/channels/create`, {
      state: {
        directoryId: id,
      },
    });
  };

  const fetchDirectoryChannels = async () => {
    try {
      const res = await apiClient.get(`${SSO_URL}${FETCH_DIRECTORY_CHANNELS}/${id}`);
      setChannels(res);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDirectoryChannels();
  }, [id]);

  return (
    <>
      <div className="page-title childparents">
        <h5>Channels List</h5>
        <button className="DefaultRedBtn" onClick={handleCreateChannel}>
          <PlusIcon />
          Add Channel
        </button>
      </div>

      <div className="table-responsive machinelist workflowtb mt-2">
        <table className="table align-middle table-nowrap mb-0">
          <thead>
            <tr>
              <th className="text-center">SNo</th>
              <th>Name</th>
              <th>Type</th>
              <th>Group</th>
              <th>UUID</th>
            </tr>
          </thead>
          <tbody>
            {channels?.map((ele, index) => {
              return (
                <tr>
                  <td className="text-center"> {index + 1} </td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if ((type = "directory")) navigate(`/dashboard/directories/channel/application/list/${ele.uuid}`);
                      else {
                        navigate(`/dashboard/channels/application/list/${ele.uuid}`);
                      }
                    }}
                  >
                    {/* <Link to={`/channel/application/list/${ele.uuid}`}> */}
                    <img
                      class="appimage-small"
                      src={ele?.configurations?.[0]?.logo || "https://cdn.simulanis.io/sso/logos/DA.png"}
                    />
                    {ele?.name}
                    {/* </Link>{" "} */}
                  </td>
                  <td className=""> {ele?.type} </td>
                  <td className=""> {ele?.group?.name} </td>
                  <td className="tokentd">
                    <Tooltip title={copyText}>
                      <span className="tokenText copyText" onClick={handleCopy(`${ele?.uuid}`, setCopyText)}>
                        {ele?.uuid}
                      </span>
                    </Tooltip>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default DirectoryChannelList;
